<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/currencyExchangeList" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.editCurrencyExchange") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.baseCurrency")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.baseCurrency')"
                >
                  <v-select
                    label="item"
                    v-model="baseCurrency"
                    :options="baseCurrencyList"
                    @input="selectedFirstItems(baseCurrency)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.status") }}
                  <span class="required">*</span>
                </small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.status')"
                >
                  <v-select
                    label="item"
                    v-model="status"
                    :options="statusList"
                    @input="selectedSecondItems(status)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.conversionCurrency")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.conversionCurrency')"
                >
                  <v-select
                    label="item"
                    v-model="currency"
                    :options="conversioncurrencyList"
                    @input="selectedThirdItems(currency)"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.validFrom")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.validFrom')"
                >
                  <datepicker
                    v-model="validFrom"
                    :placeholder="$t('placeholder.label.SelectDate')"
                    class="mb-2 font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.conversionRate')"
              >
                <vs-input
                  v-model="conversionRate"
                  :label="$t('system.label.conversionRate')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.validTo")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="$t('system.label.validTo')"
                >
                  <datepicker
                    v-model="validTo"
                    :placeholder="$t('placeholder.label.SelectDate')"
                    class="mb-2 font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="$router.push('/currencyExchangeList')"
            >{{ $t("system.label.cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateCurrencyRate"
            >{{ $t("system.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      type: "text",
      CtemplateData: {},
      baseCurrencyId: 0,
      baseCurrencyList: [],
      baseCurrency: "",
      currencyId: 0,
      conversioncurrencyList: [],
      currency: "",
      statusId: 0,
      statusList: [],
      status: "",
      validFrom: "",
      validTo: "",
      conversionRate: "",
      CurrencyById: {},
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    // getDateStr() {
    //   let s = moment(new Date()).format("DD/MM/YYYY");
    //   return s;
    // },
    breadcrumbs() {
      return [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyconfig",
        },
        { name: this.$t("system.label.editCurrencyExchange"), to: "/" },
      ];
    },
  },
  methods: {
    async editCountryDataById() {
      try {
        const response = await this.$store.dispatch(
          "currencyExchange/editTempleteDataCountryCurrency",
          this.$route.params.id
        );
        this.CurrencyById = response.data;
        this.conversionRate = this.CurrencyById.conversionRate;
        this.baseCurrency = this.CurrencyById.baseCurrencyCode;
        this.baseCurrencyId = parseInt(this.CurrencyById.baseCurrency);
        this.status = this.CurrencyById.status;
        this.currency = this.CurrencyById.currencyCode;
        this.currencyId = parseInt(this.CurrencyById.currency);
        this.validFrom = moment(this.CurrencyById.validFrom)
          .subtract(1, "month")
          .format("DD MMMM YYYY");
        this.validTo = moment(this.CurrencyById.validTo)
          .subtract(1, "month")
          .format("DD MMMM YYYY");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async selectedFirstItems(off) {
      this.CurrencyById.currencydata.currencyOptions.map((e) => {
        if (e.code + " -- " + e.name == off) {
          this.baseCurrencyId = e.id;
        }
      });
    },
    async selectedSecondItems(off) {
      this.CurrencyById.statusData.map((e) => {
        if (e.value == off) {
          this.statusId = e.id;
        }
      });
    },
    async selectedThirdItems(off) {
      this.CurrencyById.currencydata.currencyOptions.map((e) => {
        if (e.code + " -- " + e.name == off) {
          this.currencyId = e.id;
        }
      });
    },
    async updateCurrencyRate() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let data = {
          baseCurrency: this.baseCurrencyId,
          conversionRate: this.conversionRate,
          currency: this.currencyId,
          dateFormat: "dd MMMM yyyy",
          locale: "en",
          status: this.status,
          validFrom: moment(this.validFrom).format("DD MMMM YYYY"),
          validTo: moment(this.validTo).format("DD MMMM YYYY"),
        };
        const payload = {
          id: this.$route.params.id,
          data: data,
        };
        await this.$store.dispatch(
          "currencyExchange/updateCountryCurrencyAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Currency Exchange Edited Successfully!",
          type: "success",
        });
        this.$router.push("/currencyExchangeList");
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.warningText = "";
        this.errors = e.message.errors;
      }
    },
  },
  watch: {
    CurrencyById(val) {
      for (let role of val.currencydata.currencyOptions) {
        this.baseCurrencyList.push(role.code + " -- " + role.name);
      }
      for (let role of val.currencydata.currencyOptions) {
        this.conversioncurrencyList.push(role.code + " -- " + role.name);
      }
      for (let role of val.statusData) {
        this.statusList.push(role.value);
      }
    },
  },
  mounted() {
    this.editCountryDataById();
  },
};
</script>
